/*! Copyright (c) Safe As Milk. All rights reserved. */
import Cart from "cart-store";

class ProductForm extends HTMLElement {
    #boundSubmit;
    #eventAttached;
    static #formsBeingProcessed=[];
    constructor() {
        super();
        this.#boundSubmit = this.submit.bind(this);
    }
    connectedCallback() {
        this.#eventAttached = false;
        setTimeout((() => {
            this.form = this.querySelector("form");
            this.idInput = this.form.querySelector('input[name="id"]');
            this.submitButton = this.form.elements.add;
            this.stagedAction = this.querySelector("staged-action");
            this.idInput.removeAttribute("disabled");
            this.notifyOnAdd = this.hasAttribute("notify-on-add");
            this.redirectOnAdd = this.getAttribute("redirect-on-add");
            this.#eventAttached = true;
            this.form.addEventListener("submit", this.#boundSubmit);
        }));
    }
    disconnectedCallback() {
        if (this.#eventAttached) {
            this.#eventAttached = false;
            this.form.removeEventListener("submit", this.#boundSubmit);
        }
    }
    async submit(e) {
        e.preventDefault();
        const data = new FormData(e.target);
        const item = Object.fromEntries(data.entries());
        try {
            this.removeError();
            if (this.redirectOnAdd && !ProductForm.#formsBeingProcessed.includes(this.form.id)) {
                ProductForm.#formsBeingProcessed.push(this.form.id);
            }
            if (this.stagedAction) await this.stagedAction.setState("DOING");
            await Cart.add(item);
            
            // itg code for entries start  
           try {
            // 1. Get cart so we can fetch product handle
            const cartRes = await fetch('/cart.js');
            const cartJson = await cartRes.json();
            const currentItem = cartJson.items.find(i => i.id == item.id);

            if (!currentItem) throw "Cart item not found for entries";

            const handle = currentItem.handle;

            // 2. Fetch real product JSON using handle
            const productRes = await fetch(`/products/${handle}.js`);
            const productData = await productRes.json();

            // 3. Extract metaobject metafield
            const meta = productData?.metafields?.custom?.product_entries?.value;

            if (meta) {
                let multiplier = Number(meta.multiplier || 1);
                let bonus = meta.bonus_entries ? true : false;

                // 4. Calculate entries
                let basePrice = currentItem.final_line_price / 100;
                let entries = basePrice * multiplier;

                if (bonus) entries *= 2;

                // 5. ADD line item property PROPERLY
                item["properties[Entries]"] = `${entries}`;
            }

            } catch (err) {
            console.warn("Entry calc failed:", err);
            }
            try {
            await new Promise(r => setTimeout(r, 150));
            await refreshCartDrawer();
            document.dispatchEvent(new Event('cart:updated'));
            } catch (err) {
            console.error('Cart drawer refresh failed:', err);
            }
            // itg code for entries end 


            if (this.redirectOnAdd) {
                ProductForm.#formsBeingProcessed = ProductForm.#formsBeingProcessed.filter((id => id !== this.form.id));
                if (ProductForm.#formsBeingProcessed.length === 0) {
                    window.location.href = this.redirectOnAdd;
                }
            }
            if (this.stagedAction) await this.stagedAction.setState("DONE");
            const quickShop = this.closest("quick-shop");
            if (quickShop) {
                await quickShop.close();
            }
            if (this.notifyOnAdd) {
                await Cart.resetVariantsBeingAdded();
                if (!this.closest(".modal--cart")) {
                    const cart = document.querySelector(".modal--cart, .popup--cart-notification");
                    if (cart && !cart.shown) {
                        cart.open();
                    } else if (cart && cart.interval) {
                        cart.interval.reset();
                        cart.interval.start();
                    }
                }
            } else {
                await Cart.resetLatestAddedProduct();
                await Cart.resetVariantsBeingAdded(item.id);
            }
        } catch (error) {
            this.#renderError(error.message);
            if (this.stagedAction) await this.stagedAction.setState("IDLE");
            if (this.redirectOnAdd) {
                ProductForm.#formsBeingProcessed = ProductForm.#formsBeingProcessed.filter((id => id !== this.form.id));
            }
        }
    }
    removeError() {
        const error = this.querySelector(".errors");
        if (!error) return;
        error.remove();
    }
    #renderError(message) {
        this.removeError();
        if (this.submitButton) {
            const error = document.createElement("div");
            error.classList.add("errors", "qty-error", "u-small");
            error.innerHTML = message;
            this.submitButton.before(error);
        }
    }
}

customElements.define("product-form", ProductForm);
//# sourceMappingURL=product-form.js.map




// itg code for entries start 
async function refreshCartDrawer() {
  try {
    const res = await fetch('/?snippet=cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    if (!res.ok) throw new Error('Failed to fetch cart-drawer snippet: ' + res.status);
    const html = await res.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const newDrawer = doc.querySelector('cart-items');
    const oldDrawer = document.querySelector('cart-items');
    const footernewDrawer = doc.querySelector('.cart__order-details');
    const footeroldDrawer = document.querySelector('.cart__order-details');

    if (newDrawer && oldDrawer) {
      oldDrawer.innerHTML = newDrawer.innerHTML; 

      if (footernewDrawer && footeroldDrawer) {
          footeroldDrawer.innerHTML = footernewDrawer.innerHTML; 
      }

      // Dispatch a custom event so other scripts can react
      document.dispatchEvent(new CustomEvent('cart:drawer:refreshed'));
    } else {
      console.warn('cart-drawer element not found in fetched HTML or on page.');
    }
  } catch (e) {
    console.error('refreshCartDrawer error:', e);
  }
}



// itg code for entries end 
